import React, { Fragment, forwardRef, useEffect, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import SkeletonTable from '../../components/SkeletonTable'
import { Button, Col, Input, CustomInput, Form, FormGroup, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import constants from '../../constants'
import editIcon from '../../assests/images/edit-icon.svg'
import viewIcon from '../../assests/images/view-icon.svg'
import deleteIcon from '../../assests/images/delete-icon.svg'
import PropTypes from 'prop-types'
import { deleteCMS, editCMS, getCMSDetails, getCMSList } from '../../actions/cms'
import warningIcon from '../../assests/images/warning-icon.svg'
import renderHTML from 'react-render-html'
import { verifyLength } from '../../helper'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import CKEditor from '@ckeditor/ckeditor5-react'
import ToastMessage from '../../components/Toast'

const CMSManagement = forwardRef((props, ref) => {
  const adminData = useSelector(state => state.auth.adminData)
  const permission = (adminData.aPermissions && adminData.aPermissions.length && adminData.aPermissions.find(e => e.eKey === 'CMS').eType) ? adminData.aPermissions.find(e => e.eKey === 'CMS').eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [, setStatus] = useState('')
  const [type, setType] = useState('')
  const [selectedData, setSelectedData] = useState({})
  const [, setAlert] = useState(null)
  const [editCmsDetails, setEditCmsDetails] = useState({})
  const [Details, setDetails] = useState('')
  const [viewModal, setViewModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [errorSlug, setErrorSlug] = useState('')
  const [errorTitle, setErrorTitle] = useState('')
  const [errorDetails, setErrorDetails] = useState('')
  const [message, setMessage] = useState('')

  const dispatch = useDispatch()
  const token = useSelector(state => state.auth.token)
  const cmsList = useSelector(state => state.cms.cmsList)
  const cmsDetails = useSelector(state => state.cms.cmsDetails)
  const resStatus = useSelector(state => state.cms.resStatus)
  const resMessage = useSelector(state => state.cms.resMessage)

  const previousProps = useRef({
    cmsList,
    cmsDetails,
    resStatus,
    resMessage
    // excelExportData
  }).current

  const [modalMessage, setModalMessage] = useState(false)
  const toggleMessage = () => setModalMessage(!modalMessage)

  const [modalWarning, setModalWarning] = useState(false)
  const toggleWarning = () => setModalWarning(!modalWarning)

  // const processExcelExportData = data => data.map((exportData) => {
  //   const eStatus = exportData.eStatus === 'Y' ? 'Active' : 'Inactive'
  //   return {
  //     ...exportData,
  //     eStatus
  //   }
  // })

  // useEffect(() => {
  //   let data = localStorage.getItem('queryParams') ? JSON.parse(localStorage.getItem('queryParams')) : {}
  //   data === {}
  //     ? data = {
  //       CMSMnagement: props.location.search
  //     }
  //     : data.CMSMnagement = props.location.search
  //   localStorage.setItem('queryParams', JSON.stringify(data))
  // }, [props.location.search])

  useEffect(() => {
    if (props.location.state) {
      if (props.location.state.message) {
        setMessage(props.location.state.message)
        setStatus(true)
        setModalMessage(true)
      }
    }
    setLoading(true)
    dispatch(getCMSList(token))
    props.history.replace()
  }, [])

  function hideAlert () {
    setAlert(null)
  }

  // useEffect(() => {
  //   if (previousProps.excelExportData !== excelExportData) {
  //     if (excelExportData && excelExportData.results && excelExportData.results.length) {
  //       exporter.current.props = { ...exporter.current.props, data: excelExportData.results, fileName: 'CMS.xlsx' }
  //       exporter.current.save()
  //     }
  //   }
  //   return () => {
  //     previousProps.excelExportData = excelExportData
  //   }
  // }, [excelExportData])

  useEffect(() => {
    if (previousProps.cmsList !== cmsList) {
      if (cmsList) {
        setList(cmsList)
      }
      setLoading(false)
    }
    return () => {
      previousProps.cmsList = cmsList
    }
  }, [cmsList])

  useEffect(() => {
    if (previousProps.cmsDetails !== cmsDetails) {
      if (cmsDetails && cmsDetails.sDetails) {
        setDetails(cmsDetails)
        setViewModal(true)
      }
      setLoading(false)
    }
    return () => {
      previousProps.cmsDetails = cmsDetails
    }
  }, [cmsDetails])

  useEffect(() => {
    if (previousProps.resMessage !== resMessage) {
      setEditModal(false)
      if (resMessage) {
        if (resStatus) {
          dispatch(getCMSList(token))
          setMessage(resMessage)
          setStatus(resStatus)
          setModalWarning(false)
          setModalMessage(true)
        } else {
          setMessage(resMessage)
          setStatus(resStatus)
          setModalWarning(false)
          setModalMessage(true)
          setLoading(false)
        }
      }
    }
    return () => {
      previousProps.resMessage = resMessage
    }
  }, [resStatus, resMessage])

  function handleModalClose (eType) {
    if (eType === 'viewModal') {
      setViewModal(false)
    }
    if (eType === 'editModal') {
      setEditModal(false)
    }
  }

  function toggleModalClassic () {
    setViewModal(false)
    setEditModal(false)
    // setViewModal(!viewModal)
  }

  function onViewDetails (slug) {
    dispatch(getCMSDetails(slug, token))
    setLoading(true)
    // setViewModal(true)
  }

  function onEditDetails (details) {
    setEditCmsDetails(details)
    setEditModal(true)
  }

  function onChange (event, eType) {
    switch (eType) {
      case 'sSlug':
        if (verifyLength(event.target.value, 1)) {
          setErrorSlug('')
        } else {
          setErrorSlug('Required Field')
        }
        setEditCmsDetails({ ...editCmsDetails, sSlug: event.target.value })

        break
      case 'sTitle':
        if (verifyLength(event.target.value, 1)) {
          setErrorTitle('')
        } else {
          setErrorTitle('Required Field')
        }
        setEditCmsDetails({ ...editCmsDetails, sTitle: event.target.value })
        break
      default:
        break
    }
  }

  function onEditorChange (evt, editor) {
    if (verifyLength(editor.getData(), 1)) {
      setErrorDetails('')
    } else {
      setErrorDetails('Required Field')
    }
    setEditCmsDetails({ ...editCmsDetails, sDetails: editor.getData() })
  }

  function OnUpdate (e) {
    e.preventDefault()
    if (verifyLength(editCmsDetails.sSlug, 1) && verifyLength(editCmsDetails.sTitle, 1) && verifyLength(editCmsDetails.sDetails, 1) && !errorDetails && !errorSlug && !errorTitle) {
      dispatch(editCMS(
        editCmsDetails._id,
        editCmsDetails.sSlug,
        editCmsDetails.sTitle,
        editCmsDetails.sDetails,
        editCmsDetails.eStatus,
        token
      ))
      setLoading(true)
    } else {
      if (!verifyLength(editCmsDetails.sSlug, 1)) {
        setErrorSlug('Required field')
      }
      if (!verifyLength(editCmsDetails.sTitle, 1)) {
        setErrorTitle('Required field')
      }
      if (!verifyLength(editCmsDetails.sDetails, 1)) {
        setErrorDetails('Required field')
      }
    }
  }

  function onStatusChange () {
    if (editCmsDetails.eStatus === 'Y') {
      setEditCmsDetails({ ...editCmsDetails, eStatus: 'N' })
    } else {
      setEditCmsDetails({ ...editCmsDetails, eStatus: 'Y' })
    }
  }

  function onDelete () {
    dispatch(deleteCMS(selectedData._id, token))
    setLoading(true)
  }

  function onStatusUpdate () {
    const status = selectedData.eStatus === 'Y' ? 'N' : 'Y'
    dispatch(editCMS(
      selectedData._id,
      selectedData.sSlug,
      selectedData.sTitle,
      selectedData.sDetails,
      status,
      token
    ))
    setLoading(true)
    hideAlert()
  }

  function warningWithConfirmMessage (data, eType) {
    if (permission !== constants.READ_PERMISSION) {
      setType(eType)
      setSelectedData(data)
      setModalWarning(true)
    }
  }

  // function onExport () {
  //   if (cmsList.length) {
  //     exporter.current.props = { ...exporter.current.props, data: processExcelExportData(list), fileName: 'CMS.xlsx' }
  //     exporter.current.save()
  //   }
  // }

  // useImperativeHandle(ref, () => ({
  //   onExport
  // }))

  return (
  <Fragment>

       <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Sr no.</th>
              <th>Title</th>
              <th>Slug</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading
              ? <SkeletonTable numberOfColumns={5} />
              : (
                <Fragment>
                  {
                    list.length !== 0 &&
                    list.map((data, i) => (
                      <tr key={data._id}>
                        <td>{(i + 1)}</td>
                        <td>{data?.sTitle}</td>
                        <td>{data?.sSlug}</td>
                        <td>
                          <CustomInput
                            type='switch'
                            id={`switch${i + 1}`}
                            name={`switch${i + 1}`}
                            key={`switch${i + 1}`}
                            checked={data.eStatus === 'Y'}
                            onClick={() =>
                              warningWithConfirmMessage(
                                data,
                                data?.eStatus === 'Y' ? 'Inactivate' : 'Activate'
                              )
                              }
                              />
                        </td>
                        <td>
                          <ul className="action-list mb-0 d-flex">
                            {permission === constants.WRITE_PERMISSION
                              ? (
                              <li>
                                <Button color="link" className="edit" onClick={() => onEditDetails(data)}>
                                  <img src={editIcon} alt="Edit" />
                                  {/* {' '} */}
                                  <span>Edit</span>
                                </Button>
                              </li>
                                )
                              : null}
                            <li>
                              <Button color="link" className="view" onClick={() => onViewDetails(data.sSlug)} >
                                <img src={viewIcon} alt="View" />
                                {/* {' '} */}
                                <span>View</span>
                              </Button>
                            </li>
                            {permission === constants.WRITE_PERMISSION
                              ? (
                              <li>
                                <Button color="link" className="danger-btn" onClick={() => warningWithConfirmMessage(data, 'delete')}>
                                  <img src={deleteIcon} alt="Delete" />
                                  {/* {' '} */}
                                  <span>Delete</span>
                                </Button>
                              </li>
                                )
                              : null}
                          </ul>
                        </td>
                      </tr>
                    ))
                  }
                </Fragment>
                )}
          </tbody>
        </table>
      </div>
      {
        !loading && list.length === 0 &&
        (
          <div className="text-center">
            <h3>No CMS available</h3>
          </div>
        )
      }
      <Modal isOpen={viewModal} toggle={toggleModalClassic}>
        <ModalHeader toggle={toggleModalClassic}>{Details.sTitle}</ModalHeader>
        <ModalBody>
          {viewModal && renderHTML(Details.sDetails)}
        </ModalBody>
      </Modal>

      <Modal isOpen={editModal} toggle={toggleModalClassic}>
        <div className="modal-header">
          <h6 className="title title-up">Edit</h6>
        </div>
        <ModalBody>
          <Form onSubmit={OnUpdate}>
            <FormGroup>
              <Label for="slug">Slug</Label>
              <Input name="slug" placeholder="Slug" value={editCmsDetails.sSlug} onChange={event => onChange(event, 'sSlug')} />
              <p className="error-text">{errorSlug}</p>
            </FormGroup>
            <FormGroup>
              <Label for="title">Title</Label>
              <Input name="title" placeholder="Title" value={editCmsDetails.sTitle} onChange={event => onChange(event, 'sTitle')} />
              <p className="error-text">{errorTitle}</p>
            </FormGroup>
            <FormGroup>
              <Label for="status">Status</Label>
              <CustomInput onChange={onStatusChange} type="switch" id="editswitch2" name="editswitch2" label={editCmsDetails.eStatus === 'Y' ? 'Active' : 'InActive'} checked={editCmsDetails.eStatus === 'Y'} />
            </FormGroup>
            <FormGroup>
              <Label for="status">Details</Label>
              <CKEditor
                onInit={(editor) => {
                  editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                  )
                }}
                editor={DecoupledEditor}
                data={editCmsDetails.sDetails}
                onChange={onEditorChange}
              />
              <p className="error-text">{errorDetails}</p>
            </FormGroup>
          </Form>
        </ModalBody>
        <div className="modal-footer">
          <Button
            color="danger"
            data-dismiss="modal"
            type="button"
            onClick={() => { handleModalClose('editModal') }}
          >
            Close
          </Button>
          <Button
            color="success"
            type="submit"
            onClick={OnUpdate}
          >
            Update
          </Button>
        </div>
      </Modal>
      <ToastMessage
       onToggle={toggleMessage}
       isSuccess={resStatus}
       isVisible={modalMessage}
       message={message}
      />

      <Modal isOpen={modalWarning} toggle={toggleWarning} className="modal-confirm">
        <ModalBody className="text-center">
          <img className="info-icon" src={warningIcon} alt="check" />
          <h2>{`Are you sure you want to ${type} it?`}</h2>
          <Row className="row-12">
            <Col>
              <Button type="submit"className="theme-btn outline-btn full-btn"onClick={toggleWarning}>Cancel</Button>
            </Col>
            <Col>
              <Button type="submit"className="theme-btn danger-btn full-btn"onClick={type === 'delete' ? onDelete : onStatusUpdate}>{`Yes, ${type} it`}</Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  )
})
CMSManagement.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}
CMSManagement.displayName = CMSManagement
export default connect(null, null, null, { forwardRef: true })(CMSManagement)
